<div class="home-page">
  <!-- Header -->
  <header class="home-header">
    <div class="home-header__identity">
      <div class="home-header__icon" aria-hidden="true">
        <i class="pi pi-home"></i>
      </div>

      <div class="home-header__copy">
        <h1>Home</h1>
        <p>Fleet overview <span>&middot;</span> Updated just now</p>
      </div>
    </div>

    <div class="home-header__status" aria-label="All systems operational">
      <span class="home-header__status-dot"></span>
      <span>All systems operational</span>
    </div>
  </header>

  <div class="home-content">
    <!-- Stats -->
    <div class="grid stats-grid">
      <div class="col-12 sm:col-6 xl:col-3">
        <div class="stat-card stat-card--blue stat-card--loading" *ngIf="loadingVehicles$ | async">
          <p-skeleton shape="circle" size="3rem"></p-skeleton>
          <div class="stat-card__body">
            <p-skeleton width="70%" height="0.85rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="45%" height="1.6rem"></p-skeleton>
          </div>
        </div>
        <div
          class="stat-card stat-card--blue"
          *ngIf="statisticsVehicles$ | async as vehicleStatistics"
        >
          <div class="stat-card__icon">
            <i class="pi pi-truck"></i>
          </div>
          <div class="stat-card__body">
            <span class="stat-card__label">Vehicles</span>
            <span class="stat-card__value">{{ vehicleStatistics.count }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 sm:col-6 xl:col-3">
        <div class="stat-card stat-card--green stat-card--loading" *ngIf="loadingVehicles$ | async">
          <p-skeleton shape="circle" size="3rem"></p-skeleton>
          <div class="stat-card__body">
            <p-skeleton width="70%" height="0.85rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="45%" height="1.6rem"></p-skeleton>
          </div>
        </div>
        <div
          class="stat-card stat-card--green"
          *ngIf="statisticsVehicles$ | async as vehicleStatistics"
        >
          <div class="stat-card__icon">
            <i class="pi pi-check-circle"></i>
          </div>
          <div class="stat-card__body">
            <span class="stat-card__label">Active vehicles</span>
            <span class="stat-card__value">{{ vehicleStatistics.active }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 sm:col-6 xl:col-3">
        <div class="stat-card stat-card--orange stat-card--loading" *ngIf="loadingActiveIssues$ | async">
          <p-skeleton shape="circle" size="3rem"></p-skeleton>
          <div class="stat-card__body">
            <p-skeleton width="70%" height="0.85rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="45%" height="1.6rem"></p-skeleton>
          </div>
        </div>
        <div
          class="stat-card stat-card--orange"
          *ngIf="statisticsActiveIssues$ | async as activeIssuesStatistics"
        >
          <div class="stat-card__icon">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div class="stat-card__body">
            <span class="stat-card__label">Vehicles with active issues</span>
            <span class="stat-card__value">{{ vehicleCount }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 sm:col-6 xl:col-3">
        <div class="stat-card stat-card--purple stat-card--loading" *ngIf="loadingActiveIssues$ | async">
          <p-skeleton shape="circle" size="3rem"></p-skeleton>
          <div class="stat-card__body">
            <p-skeleton width="70%" height="0.85rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="45%" height="1.6rem"></p-skeleton>
          </div>
        </div>
        <div
          class="stat-card stat-card--purple"
          *ngIf="statisticsActiveIssues$ | async as activeIssuesStatistics"
        >
          <div class="stat-card__icon">
            <i class="pi pi-pencil"></i>
          </div>
          <div class="stat-card__body">
            <span class="stat-card__label">Signed off today</span>
            <span class="stat-card__value">{{ activeIssuesStatistics.signed_off_last_week }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts -->
    <div class="grid chart-grid" *ngIf="false">
      <div class="col-12 xl:col-6">
        <section class="chart-card">
          <div class="chart-card__header">
            <h2>Vehicle status</h2>
            <p>Real-time breakdown of fleet availability</p>
          </div>

          <div class="chart-card__body">
            <div class="chart-card__visual">
              <p-chart
                type="doughnut"
                [data]="vehicleStatusChartData"
                [options]="doughnutChartOptions"
              ></p-chart>

              <div class="chart-card__center">
                <strong>{{ vehicleStatusTotal }}</strong>
                <span>Vehicles</span>
              </div>
            </div>

            <div class="chart-legend">
              <div
                class="chart-legend__item"
                *ngFor="let item of vehicleStatusLegend"
              >
                <div class="chart-legend__label">
                  <span
                    class="chart-legend__dot"
                    [style.background-color]="item.color"
                  ></span>
                  <span>{{ item.label }}</span>
                </div>

                <span class="chart-legend__percentage">
                  {{ item.percentage }}
                </span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="col-12 xl:col-6">
        <section class="chart-card">
          <div class="chart-card__header">
            <h2>Technical records</h2>
            <p>Open records by category, last 30 days</p>
          </div>

          <div class="chart-card__body">
            <div class="chart-card__visual">
              <p-chart
                type="doughnut"
                [data]="technicalRecordsChartData"
                [options]="doughnutChartOptions"
              ></p-chart>

              <div class="chart-card__center">
                <strong>{{ technicalRecordsTotal }}</strong>
                <span>Records</span>
              </div>
            </div>

            <div class="chart-legend">
              <div
                class="chart-legend__item"
                *ngFor="let item of technicalRecordsLegend"
              >
                <div class="chart-legend__label">
                  <span
                    class="chart-legend__dot"
                    [style.background-color]="item.color"
                  ></span>
                  <span>{{ item.label }}</span>
                </div>

                <span class="chart-legend__percentage">
                  {{ item.percentage }}
                </span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- service reminders -->
    <div class="reminders-section mb-4">
      <div class="reminders-section__header">
        <div class="reminders-section__title">
          <i class="pi pi-bell"></i>
          <div>
            <span class="reminders-section__label">Service Reminders</span>
            <span class="reminders-section__sub"
              >Sorted by urgency · KM shown is remaining before service</span
            >
          </div>
        </div>
      </div>

      <div *ngIf="serviceRemindersLoading" class="reminders-loading">
        <p-progressBar mode="indeterminate" styleClass="w-full"></p-progressBar>
      </div>

      <div
        *ngIf="!serviceRemindersLoading && serviceReminders.length === 0"
        class="reminders-empty"
      >
        <i class="pi pi-check-circle"></i>
        <span>No active service reminders</span>
      </div>

      <div
        *ngIf="!serviceRemindersLoading && serviceReminders.length > 0"
        class="reminders-grid"
      >
        <div
          *ngFor="let r of serviceReminders; trackBy: trackByReminder"
          class="reminder-card"
          [ngClass]="'reminder-card--' + getReminderUrgency(r)"
        >
          <div class="reminder-card__top">
            <div class="reminder-card__vehicle">
              <i class="pi pi-truck"></i>
              <strong>{{ r.vehicle_reference }}</strong>
            </div>
            <span
              class="reminder-badge"
              [ngClass]="'reminder-badge--' + getReminderUrgency(r)"
            >
              <ng-container [ngSwitch]="getReminderUrgency(r)">
                <ng-container *ngSwitchCase="'critical'">Urgent</ng-container>
                <ng-container *ngSwitchCase="'warning'">Due soon</ng-container>
                <ng-container *ngSwitchDefault>OK</ng-container>
              </ng-container>
            </span>
          </div>

          <div class="reminder-card__km">
            <span class="reminder-card__km-value">{{
              r.service_delta | number
            }}</span>
            <span class="reminder-card__km-unit">km remaining</span>
          </div>

          <div class="reminder-card__interval" *ngIf="r.service_interval">
            <span>of {{ r.service_interval | number }} km interval</span>
          </div>

          <div class="reminder-card__rule">
            <div
              class="reminder-card__rule-fill"
              [ngClass]="'reminder-card__rule-fill--' + getReminderUrgency(r)"
              [style.width.%]="getReminderProgress(r)"
            ></div>
          </div>

          <div class="reminder-card__footer" *ngIf="r.service_due_date">
            <i class="pi pi-calendar"></i>
            <span>{{ r.service_due_date | date : "dd MMM yyyy" }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- predictive maintenance -->
    <div class="predict-section mb-4">
      <div class="predict-section__header">
        <div class="predict-section__title">
          <i class="pi pi-chart-line"></i>
          <div>
            <span class="predict-section__label">Predictive Maintenance</span>
            <span class="predict-section__sub"
              >Vehicles overdue on their service cadence · recomputed
              daily</span
            >
          </div>
        </div>
        <span
          class="predict-count"
          *ngIf="!predictionsLoading && predictions.length > 0"
          >{{ predictions.length }} critical</span
        >
      </div>

      <div *ngIf="predictionsLoading" class="predict-loading">
        <p-progressBar mode="indeterminate" styleClass="w-full"></p-progressBar>
      </div>

      <div
        *ngIf="!predictionsLoading && predictions.length === 0"
        class="predict-empty"
      >
        <i class="pi pi-check-circle"></i>
        <span>No vehicles are currently flagged at risk</span>
      </div>

      <div
        *ngIf="!predictionsLoading && predictions.length > 0"
        class="predict-grid"
      >
        <div
          *ngFor="let p of predictions; trackBy: trackByPrediction"
          class="predict-card predict-card--clickable"
          [ngClass]="'predict-card--' + p.risk_level"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Open technical records for vehicle ' + (p.vehicle_reference || '')"
          (click)="openVehicle(p)"
          (keydown.enter)="openVehicle(p)"
          (keydown.space)="openVehicle(p)"
        >
          <div class="predict-card__top">
            <div class="predict-card__vehicle">
              <i class="pi pi-truck"></i>
              <span class="predict-card__fleet">Fleet</span>
              <strong>{{ p.vehicle_reference || "—" }}</strong>
              <i class="pi pi-chevron-right predict-card__go" aria-hidden="true"></i>
            </div>
            <span class="predict-score" [title]="'Risk score ' + p.risk_score + ' / 100'">
              {{ p.risk_score }}
            </span>
          </div>

          <p class="predict-card__summary" *ngIf="predictSummary(p) as summary">
            {{ summary }}
          </p>

          <div class="predict-card__reco" *ngIf="p.recommendation">
            <i class="pi pi-sparkles"></i>
            <span>{{ p.recommendation }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- active issues table -->
    <div class="surface-card border-round shadow-1 p-4 mb-4">
      <p-table
        [rows]="5"
        [responsiveLayout]="'scroll'"
        [value]="activeIssues"
        [loading]="activeIssuesLoading"
        styleClass="app-table"
      >
        <ng-template pTemplate="caption">
          <div class="flex flex-row">
            <i
              class="pi pi-exclamation-triangle text-orange-500 text-2xl mr-2"
            ></i>
            <div class="flex flex-column mb-2">
              <span class="text-900 font-medium text-xl">Active issues</span>
              <span class="text-600 font-medium text-sm">
                Most recent unresolved issues across the fleet
              </span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Vehicle</th>
            <th>Issue</th>
            <th>Status</th>
            <th>Last updated</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-issue>
          <tr>
            <td>{{ issue.vehicle_reference }}</td>
            <td>{{ issue.description }}</td>
            <td>
              <span
                class="status-badge"
                [class.status-badge--open]="!issue.signed_off"
                [class.status-badge--closed]="issue.signed_off"
              >
                {{ issue.signed_off ? "Signed off" : "Open" }}
              </span>
            </td>
            <td>{{ issue.date_updated | dateAsAgo }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- recent activity table -->
    <div
      class="surface-card border-round shadow-1 p-4 mb-4"
      *ngIf="(mostRecentChangesActiveIssues$ | async)?.length"
    >
      <p-table
        [rows]="5"
        [responsiveLayout]="'scroll'"
        [value]="(mostRecentChangesActiveIssues$ | async) ?? []"
        styleClass="app-table"
      >
        <ng-template pTemplate="caption">
          <div class="flex flex-row">
            <i class="pi pi-history text-blue-500 text-2xl mr-2"></i>
            <div class="flex flex-column mb-2">
              <span class="text-900 font-medium text-xl">Recent activity</span>
              <span class="text-600 font-medium text-sm">
                Most recent changes to active issues
              </span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Vehicle</th>
            <th>Change</th>
            <th>Status</th>
            <th>Updated</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-issue>
          <tr>
            <td>{{ issue.vehicle_reference }}</td>
            <td>
              <span *ngIf="issue.signoff_type" class="record-tag">
                {{ issue.signoff_type }}
              </span>
            </td>
            <td>
              <span
                class="status-badge"
                [class.status-badge--open]="!issue.signed_off"
                [class.status-badge--closed]="issue.signed_off"
              >
                {{ issue.signed_off ? "Signed off" : "Updated" }}
              </span>
            </td>
            <td>{{ issue.date_updated | dateAsAgo }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
